import { MedplumClient } from "@medplum/core";

import { joinReferenceString } from "@/utils/medplum";

export async function fetchAllergiesBadges(medplum: MedplumClient, clientId: string) {
  const allergies = await medplum.searchResources("AllergyIntolerance", {
    patient: joinReferenceString("Patient", clientId),
  });

  return allergies;
}
